import React from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';

import { CheckIcon } from '@snapask/common-components';

import { SECURE_PAYMENT } from '@dragonfruit/constants/premiumPage';

import styles from './SecurePaymentStatement.scss';
import imageSecurepayment from './images/img_plan_securepayment.svg';

const statements = t =>
  t('premium.secure.statement', {
    returnObjects: true,
    defaultValue: [],
  });

const SecurePaymentStatement = ({ t }) => (
  <section className={styles.root} id={SECURE_PAYMENT}>
    <div className={styles.left}>
      <h3>{t('premium.secure.title')}</h3>
      <h5 className={styles.subTitle}>{t('premium.secure.subTitle')}</h5>
      <div className={styles.statements}>
        {statements(t).map(statement => (
          <div className={styles.statement} key={statement}>
            <div className={styles.icon}>
              <CheckIcon width={14} height={14} />
            </div>
            <h6>{statement}</h6>
          </div>
        ))}
      </div>
    </div>
    <div className={styles.right}>
      <img src={imageSecurepayment} />
    </div>
  </section>
);

SecurePaymentStatement.propTypes = {
  t: func.isRequired,
};

export default translate(['premium'])(SecurePaymentStatement);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SecurePaymentStatement/SecurePaymentStatement.jsx